import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { DataContext } from '../../context/DataContext';
import {
  isNotificationSupported,
  getNotificationPermission,
  requestNotificationPermission
} from '../../utils/notificationUtils';
import './notification-prompt.css';

const BellIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    stroke="#1a1a2e"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 12a8 8 0 0116 0c0 4 2 6 3 7H5c1-1 3-3 3-7z" />
    <path d="M12 27a4 4 0 008 0" />
  </svg>
);

export default function NotificationPrompt() {
  const { currentUser } = useContext(AuthContext);
  const { activities } = useContext(DataContext);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!currentUser) return;
    if (localStorage.getItem('lightway-notif-dismissed') === 'true') return;
    if (!isNotificationSupported()) return;
    if (getNotificationPermission() !== 'default') return;
    if (!activities || activities.length === 0) return;

    const timer = setTimeout(() => setVisible(true), 1000);
    return () => clearTimeout(timer);
  }, [currentUser, activities]);

  const handleAllow = async () => {
    await requestNotificationPermission(currentUser.uid);
    setVisible(false);
  };

  const handleDismiss = () => {
    localStorage.setItem('lightway-notif-dismissed', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="notif-prompt">
      <div className="notif-prompt-header">
        <BellIcon />
        <h3 className="notif-prompt-title">Stay on track with your goals</h3>
      </div>
      <p className="notif-prompt-desc">
        Get a gentle reminder when your monthly goals need attention.
        We'll only notify you when it matters.
      </p>
      <div className="notif-prompt-actions">
        <button className="notif-prompt-btn" onClick={handleAllow}>
          Allow Notifications
        </button>
        <button className="notif-prompt-dismiss" onClick={handleDismiss}>
          Not Now
        </button>
      </div>
    </div>
  );
}
